import { z } from 'zod';

import { type QueriesType } from '../telematics/types';
import { Api, ApiFilterBuilder } from '@automapa/svelte-automapa-template';

export const GetCalcStatusResponse = z.object({
    to_calculate: z.number(),
    in_calculation: z.number(),
    pending: z.object({
        to_calculate: z.number(),
        in_calculation: z.number()
    })
});
export type GetCalcStatusResponse = z.infer<typeof GetCalcStatusResponse>;

export class NotificationSystemApi {
    public static async countNotGeocodedLocations(api: Api): Promise<{ count: number }> {
        // POST http://etoll.mdymowski.indigo/api/view_connection/count_not_geocoded_locations
        return api.getData<QueriesType, { count: number }>(
            'post',
            '/locations/count',
            { coords_accepted: false },
            z.any(),
            z.object({ count: z.number().catch(0) })
        );
    }

    public static async countRoutesToCalculate(api: Api): Promise<{ count: number }> {
        // POST http://etoll.mdymowski.indigo/api/view_connection/count_routes_to_calculate
        return api.getData<QueriesType, { count: number }>(
            'post',
            '/view_connection/count_routes_to_calculate',
            {},
            z.any(),
            z.object({ count: z.number().catch(0) })
        );
    }

    // POST http://etoll.mdymowski.indigo/api/view_connection/count_routes_in_calculation
    public static async countRoutesInCalculation(api: Api): Promise<{ count: number }> {
        return api.getData<QueriesType, { count: number }>(
            'post',
            '/view_connection/count_routes_in_calculation',
            {},
            z.any(),
            z.object({ count: z.number().catch(0) })
        );
    }

    // POST http://etoll.mdymowski.indigo/api/view_connection/calc_routes_needed_to_calculate
    public static async calcRoutesNeededToCalculate(api: Api): Promise<any> {
        return api.getData<QueriesType, any>(
            'post',
            '/view_connection/calc_routes_needed_to_calculate',
            {},
            z.any(),
            z.any()
        );
    }

    public static async getRouteCalcStatus(api: Api): Promise<GetCalcStatusResponse> {
        // POST http://etoll.mdymowski.indigo/api/view_connection/get_route_calc_status
        return api.getData<QueriesType, GetCalcStatusResponse>(
            'post',
            '/view_connection/get_route_calc_status',
            {},
            z.any(),
            GetCalcStatusResponse
        );
    }
}
